import React from 'react'

import { File } from './File'

interface FileListProps extends React.HTMLAttributes<HTMLUListElement> {
  'aria-label'?: string;
  children: React.ReactNode;
}

export function FileList ({
  'aria-label': ariaLabel = 'File list',
  children,
  ...props
}: FileListProps) {
  return (
    <ul {...props} aria-label={ariaLabel} className='flex flex-col gap-3'>
      {children}
    </ul>
  )
}

FileList.File = File
